/* eslint-disable class-methods-use-this */
import Flickity from 'flickity';
import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * MaintenanceSlider class.
 */
export default class MaintenanceSlider extends Base {
  static config = {
    log: isDev(),
    name: 'MaintenanceSlider',
    refs: ['sliderImage', 'sliderContent', 'arrowPrevious', 'arrowNext', 'dots[]'],
  };

  /**
   * Mounted.
   *
   * @return {void}
   */
  mounted() {
    // Slider content
    this.sliderContent = new Flickity(this.$refs.sliderContent, {
      cellAlign: 'left',
      wrapAround: true,
      draggable: false,
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: this.handleSliderContentReady,
        change: this.handleSliderContentChange,
      },
    });
    // Slider image
    this.sliderImage = new Flickity(this.$refs.sliderImage, {
      cellAlign: 'left',
      wrapAround: true,
      draggable: false,
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: this.handleSliderImageReady,
      },
    });
  }

  /**
   * Handle slider content ready.
   */
  handleSliderContentReady() {
    this.$refs.sliderContent.classList.add('is-flickity-ready');
  }

  /**
   * Handle slider content change.
   */
  handleSliderContentChange(index) {
    this.$refs.dots.forEach(($dot) => {
      $dot.classList.remove('is-active');
    });
    this.$refs.dots[index].classList.add('is-active');
  }

  /**
   * Handle slider image ready.
   */
  handleSliderImageReady() {
    this.$refs.sliderImage.classList.add('is-flickity-ready');
  }

  /**
   * On arrow previous click
   */
  onArrowPreviousClick() {
    this.sliderContent.previous();
    this.sliderImage.previous();
  }

  /**
   * On arrow next click
   */
  onArrowNextClick() {
    this.sliderContent.next();
    this.sliderImage.next();
  }

  /**
   * On dots click
   *
   * @param {event} event The click event
   */
  onDotsClick(event) {
    const index = parseInt(((event.target || {}).dataset || {}).index || 0, 10);
    this.sliderContent.select(index);
    this.sliderImage.select(index);
  }

  /**
   * Destroyed.
   */
  destroyed() {
    if (this.sliderContent) {
      this.$refs.sliderContent.classList.remove('is-flickity-ready');
      this.sliderContent.destroy();
      this.sliderContent = null;
    }

    if (this.sliderImage) {
      this.$refs.sliderImage.classList.remove('is-flickity-ready');
      this.sliderImage.destroy();
      this.sliderImage = null;
    }
  }
}
